import { render } from "./training.vue?vue&type=template&id=da2e8d12"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"
script.render = render

export default script